/**
 * @description
 * Deployment health service for monitoring deployment health and scheduling checks.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date January 8, 2025
 */

import { BaseAPIClient } from "../core/base-client";

/**
 * Deployment health service
 */
export class DeploymentHealthService extends BaseAPIClient {
  /**
   * Get deployment health status
   */
  async getDeploymentHealth(deploymentId: string): Promise<{
    healthy: boolean;
    status: string;
    responseTime: number;
    checkedAt: string;
    error?: string;
  }> {
    return this.request(`/deployments/${deploymentId}/health`);
  }

  /**
   * Get deployment health history
   */
  async getDeploymentHealthHistory(deploymentId: string): Promise<Array<{
    id: string;
    deploymentId: string;
    status: string;
    responseTime: number;
    checkedAt: string;
    details: {
      cpu: string;
      memory: string;
      disk: string;
    };
  }>> {
    return this.request(`/deployments/${deploymentId}/health/history`);
  }

  /**
   * Schedule deployment health checks
   */
  async scheduleDeploymentHealthChecks(deploymentId: string, intervalMinutes: number): Promise<void> {
    await this.request(`/deployments/${deploymentId}/health/schedule`, {
      method: 'POST',
      body: JSON.stringify({ intervalMinutes }),
    });
  }
}

// Export singleton instance
export const deploymentHealthService = new DeploymentHealthService();
